import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Truck, XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function SubscriptionCancel({ type = 'subscription' }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <Truck className="h-8 w-8 text-orange-500" />
          <span className="text-xl font-bold text-slate-900">True Choice Enterprise</span>
        </Link>

        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-10 w-10 text-red-500" />
        </div>
        
        <h2 className="text-2xl font-bold text-slate-900 mb-2">Payment Cancelled</h2>
        <p className="text-slate-600 mb-6">
          {type === 'subscription'
            ? 'Your subscription payment was cancelled. You can try again anytime.'
            : 'Your background check payment was cancelled.'}
        </p>
        
        <Button onClick={() => navigate('/dashboard')} className="btn-accent w-full" data-testid="go-to-dashboard">
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
